function isValidAnswer(answer) {
  return typeof answer === "object" && answer !== null && "filter_key" in answer && "filter" in answer && "psr_id" in answer && "text" in answer;
}
function buildEventData(question, answer, stepCount) {
  let questionPayload;
  if (typeof question === "object" && "parent_term" in question) {
    questionPayload = {
      parent_term: question.parent_term,
      text: question.text
    };
  } else {
    questionPayload = { text: question.text };
  }
  let answerPayload;
  if (answer !== null && typeof answer === "object" && "filter_key" in answer && "filter" in answer && "psr_id" in answer && "text" in answer) {
    answerPayload = {
      filter: answer.filter,
      filter_key: answer.filter_key,
      psr_id: answer.psr_id,
      secondary_text: answer.secondary_text,
      text: answer.text
    };
  }
  return {
    answer: answerPayload,
    question: questionPayload,
    stepCount
  };
}
const calculateTotalSteps = (question) => {
  let maxDepth = 1;
  for (const { answer } of question.answers) {
    if (answer.question) {
      maxDepth = Math.max(maxDepth, 1 + calculateTotalSteps(answer.question));
    }
  }
  return maxDepth;
};
const getShowSkip = (hideSkip, showSkipOnFirstStepOnly, currentStep, completed) => {
  if (hideSkip || completed) {
    return false;
  }
  if (showSkipOnFirstStepOnly) {
    return currentStep === 1;
  }
  return true;
};
const getShowComponent = (exists, showOnFirstStepOnly, currentStep) => {
  if (!exists) {
    return false;
  }
  if (showOnFirstStepOnly) {
    return currentStep === 1;
  }
  return true;
};
export {
  buildEventData,
  calculateTotalSteps,
  getShowComponent,
  getShowSkip,
  isValidAnswer
};
